import {axios} from "@/api/config";
// 查询安全风险信息管理列表
export function listRiskInfo(params) {
  return axios.get(`/riskInfo/list`, params, true);
}
export function getDangersrcList(params) {
  return axios.get(`/dangersrc/getDangersrcList`,params, true);
}
// 查询安全风险信息管理详细
export function getRiskInfo(riskId) {
  return axios.get(`/riskInfo/${riskId}`, riskId, true)
}

// 新增安全风险信息管理
export function addRiskInfo(params) {
  return axios.post('/riskInfo/addRiskInfo', params, false);
}

// 修改安全风险信息管理
export function updateRiskInfo(params) {
  return axios.post('/riskInfo/editRiskInfo', params, false);
}


// 删除安全风险信息管理
export function delRiskInfo(riskId) {
  return axios.delete(`/riskInfo/${riskId}`, true)
}

